import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { TextField, Button, Box, Typography, Container } from "@mui/material";
import apiClient from "../components/apiClient";
import { useCart } from "../components/CartContext";
import Navbar from "./Navbar";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [ipAddress, setIpAddress] = useState("");

  // Helper function untuk mengecek apakah token sudah kedaluwarsa
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIpAddress(data.ip);
        console.log("IP Address:", data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  }, []);

  const isTokenExpired = (token) => {
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
      const currentTime = Math.floor(Date.now() / 1000); // Waktu sekarang dalam detik
      return payload.exp < currentTime; // True jika token sudah kedaluwarsa
    } catch (error) {
      console.error("Error decoding token:", error);
      return true;
    }
  };

  const { setIsLoggedIn, fetchCartCount, clearCart } = useCart();

  // Hapus userId jika token kedaluwarsa
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (isTokenExpired(token)) {
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
    }
  }, []);

  // const handleLogin = async () => {
  //   try {
  //     const response = await axios.post(
  //       "http://192.168.1.3:2000/user/login",
  //       {
  //         email: email,
  //         password: password,
  //       }
  //     );

  //     if (response.data.message === "Email tidak ditemukan") {
  //       navigate("/register");
  //     } else if (response.data.message === "OTP telah dikirim ke email Anda") {
  //       navigate("/verify-otp", { state: { email } });
  //     } else if (response.data.token) {
  //       // Simpan token dan userId ke localStorage
  //       localStorage.setItem("token", response.data.token);
  //       if (response.data.userId) {
  //         localStorage.setItem("userId", response.data.userId);
  //         // localStorage.setItem("userId", userId);
  //         console.log(localStorage.getItem("userId"));

  //       }

  //       // Kirim OTP dan navigasi ke halaman verifikasi
  //       await axios.post("http://192.168.1.3:2000/user/send-otp", { email });
  //       navigate("/verify-otp", { state: { email } });
  //     } else {
  //       setErrorMessage("Login gagal, token tidak ditemukan.");
  //     }
  //   } catch (error) {
  //     console.error("Error login:", error);
  //     setErrorMessage("Email atau password salah.");
  //   }
  // };

  // localStorage.clear();
  // const handleLogin = async () => {
  //   try {
  //     const response = await apiClient.post("/user/login",
  //       {
  //         email: email,
  //         password: password,
  //        }
  //       );
  //     if (response.data.message === "Email tidak ditemukan") {
  //       navigate("/register");
  //     } else if (response.data.message === "OTP telah dikirim ke email Anda") {
  //       navigate("/verify-otp", { state: { email } });
  //     } else if (response.data.token) {
  //       localStorage.setItem("token", response.data.token);
  //       if (response.data.userId) {
  //         localStorage.setItem("userId", response.data.userId);
  //       }

  //       await apiClient.post("/user/send-otp", { email });
  //       navigate("/verify-otp", { state: { email } });
  //     } else {
  //       setErrorMessage("Login gagal, token tidak ditemukan.");
  //     }
  //   } catch (error) {
  //     console.error("Error login:", error);
  //     setErrorMessage("Email atau password salah.");
  //   }
  // };

  const handleLogin = async () => {
    try {
      const response = await apiClient.post("/user/login", {
        email,
        password,
        ip_add: ipAddress,
      });
      // const success = await doLogin();

      if (response.data.message === "Email tidak ditemukan") {
        navigate("/register");
      } else if (response.data.token) {
        localStorage.setItem("token", response.data.token);

        if (response.data.userId) {
          localStorage.setItem("userId", response.data.userId);
        }

        setIsLoggedIn(true);
        await fetchCartCount();

        const pendingAddToCart = JSON.parse(
          localStorage.getItem("pendingAddToCart")
        );

        if (pendingAddToCart) {
          // Clear the pending data so it doesn't repeat
          localStorage.removeItem("pendingAddToCart");

          // Redirect back to detail page
          navigate(pendingAddToCart.from, {
            state: { triggerAddToCart: true },
          });
        } else {
          navigate("/"); // or wherever normally
        }

        const redirectTo = location.state?.from || "/";
        navigate(redirectTo);

        // Navigate directly after successful login
        // navigate("/"); // or your target page
      } else {
        setErrorMessage("Login gagal, token tidak ditemukan.");
      }
    } catch (error) {
      console.error("Error login:", error);
      setErrorMessage("Email atau password salah.");
    }
  };

  const handleForgotPassword = () => {
    // Redirect to forgot password page
    navigate("/forgot-password");

    // OR open modal for inline reset (optional)
    // OR call an API to send a reset link
  };

  return (
    <>
      <Navbar />
      <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
        <div className="bg-white w-full max-w-xl rounded-lg shadow-xl p-8 space-y-6">
          <h1 className="text-3xl md:text-5xl font-extrabold text-center text-gray-900">
            Sign In
          </h1>

          {errorMessage && (
            <p className="text-red-500 text-center text-sm">{errorMessage}</p>
          )}

          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent page reload
              handleLogin(); // Call your login function
            }}
            className="space-y-4"
          >
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-md bg-gray-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
                placeholder="you@example.com"
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-md bg-gray-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
                placeholder="••••••••"
              />

              {/* Forgot Password link */}
              <div className="text-right mt-2">
                <button
                  onClick={handleForgotPassword}
                  className="text-sm text-[#CCAB5C] hover:underline font-medium"
                  type="button"
                >
                  Forgot password?
                </button>
              </div>
            </div>

            {/* Continue Button */}
            <button
              type="submit" // Important: triggers form submit
              className="w-full py-3 bg-black text-white text-lg font-semibold rounded-md hover:bg-gray-800 transition-all duration-300"
            >
              CONTINUE
            </button>
          </form>

          {/* Signup link */}
          <p className="text-center text-sm">
            New to Musique?{" "}
            <a
              href="/register"
              className="text-[#CCAB5C] font-semibold hover:underline"
            >
              Sign Up now
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
